import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LocationDetail from './pages/LocationDetail';
import ContactInfo from './pages/ContactInfo';
import MediaTest from './pages/MediaTest';
import MobileTest from './pages/MobileTest';
import CameraTest from './pages/CameraTest';

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error in development only
    if (import.meta.env.DEV) {
      console.error('Error caught by boundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Bir hata oluştu</h1>
            <p className="text-gray-600 mb-6">Sayfa yüklenirken bir sorun yaşandı.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
            >
              Sayfayı Yenile
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/muze/:muzeCode/:sectionNo" element={<LocationDetail />} />
            <Route path="/contact-info" element={<ContactInfo />} />
            <Route path="/media-test" element={<MediaTest />} />
            <Route path="/mobile-test" element={<MobileTest />} />
            <Route path="/camera-test" element={<CameraTest />} />
          </Routes>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
